'use client';

export default function FilterLabel({ children }) {
    return <span className="text-lg mb-2 text-gray-500">{children}</span>;
}
